<template>
  <div class="flex justify-center items-center mt-2">
    <div class="w-96 min-h-[10px]">
      <p v-if="errorMessage" class="text-red-700">{{ errorMessage }}</p>
      <div v-else-if="isLoading">
        <LayupSpinner />
        <p class="text-black">Loading...</p>
      </div>
      <div v-else class="max-w-md mx-auto bg-white rounded-xl text-center">
        <img
          v-if="isRewardFlat"
          src="https://res.cloudinary.com/layup/image/upload/v1758636474/BOOST_Widget_-_Intro_-_Flat_Fee_wwwtc5.png"
          alt="Flat Amount Reward - How It Works"
        />
        <img
          v-else
          src="https://res.cloudinary.com/layup/image/upload/v1758636474/BOOST_Widget_-_Intro_-_Percentage_zeueuk.png"
          alt="Percentage Reward - How It Works"
        />
        <div class="pt-2">
          <button
            @click="getStarted()"
            variant="outline-secondary"
            class="mt-6 w-full bg-brand-500 text-white font-bold py-2 rounded-lg hover:bg-brand-700 disabled:opacity-60 disabled:bg-brand-600"
          >
            Get Started
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import LayupSpinner from '@/components/common/LayupSpinner.vue';
import { NetworkError } from '@/errors';
import { useWidgetStore } from '@/stores/widget';
import { createException, createWarning } from '@/utils/monitoring.utils';
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const router = useRouter();
const route = useRoute();
const widgetStore = useWidgetStore();

const errorMessage = ref('');
const isLoading = ref(false);
const isRewardFlat = ref(false);

const init = async () => {
  const id = route.params.id as string;
  isLoading.value = true;
  errorMessage.value = '';
  try {
    if (!id || id.length !== 24) {
      errorMessage.value = 'Boost Reward order could not be created. Invalid merchant id.';
      return;
    }
    const merchant = await widgetStore.getBoostMerchant(id);
    if (!merchant.voucherSettings || !merchant.voucherSettings.active) {
      errorMessage.value = 'Merchant does not support Boost Rewards.';
      return;
    }
    isRewardFlat.value = merchant.voucherSettings.rewardType === 'FLAT';
  } catch (error: any) {
    if (error instanceof NetworkError) {
      createWarning(error);
      errorMessage.value = 'Boost Reward order could not be created. Network error.';
    } else if (error.response?.status === 404) {
      errorMessage.value = 'Boost Reward order could not be created. Merchant not found.';
    } else {
      createException(error);
      errorMessage.value = 'Boost Reward order could not be created. An unexpected error occurred. Please try again.';
    }
  } finally {
    isLoading.value = false;
  }
};

init();

const getStarted = async () => {
  router.push({ name: 'BoostConfiguration' });
};
</script>
